module.exports = __webpack_public_path__ + "img/case_bg.fc241be5.png";